<div @stagger class="flex flex-wrap gap-6">
  @for (card of cards$ | async; track card.label) {
  <app-home-card
    [titulo]="card.label"
    [icone]="card.icon!"
    [link]="card.route"
    [texto]="card.textoCard"
    [textoLink]="card.textoCardLink"
    @fadeInUp
  >
  </app-home-card>
  }
</div>
